import React from "react";

const WhyUs = () => {
  return (
    <section id="why-us" className="py-36 px-6 bg-gray-50">
      <div className="container mx-auto">
        {/* Section Title */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-primary text-center mb-10">
          Why Arancia?
        </h2>
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-center mb-12">
          Discover what sets us apart and why businesses trust Arancia to
          transform their operations with tailored Odoo solutions.
        </p>

        {/* Points Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          <div className="flex items-center space-x-4">
            <div className="p-4 bg-primary text-white rounded-full shadow-lg">
              <svg
                className="w-8 h-8"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M9 12l2 2 4-4" />
              </svg>
            </div>
            <div className="text-lg text-gray-700">
              <strong>Experienced Team:</strong> Our leadership team brings over
              80 years of collective experience.
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="p-4 bg-secondary text-white rounded-full shadow-lg">
              <svg
                className="w-8 h-8"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10 12l2 2 4-4" />
                <path d="M14 8h6v12H4V8h6" />
              </svg>
            </div>
            <div className="text-lg text-gray-700">
              <strong>Tailored Solutions:</strong> We offer customized Odoo
              implementations that fit your specific business needs.
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="p-4 bg-accent1 text-white rounded-full shadow-lg">
              <svg
                className="w-8 h-8"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 4l4 4-4 4" />
                <path d="M12 16l-4 4 4 4" />
              </svg>
            </div>
            <div className="text-lg text-gray-700">
              <strong>Innovation & Reliability:</strong> We blend industry
              expertise with fresh perspectives to offer reliable, cutting-edge
              solutions.
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="p-4 bg-accent2 text-white rounded-full shadow-lg">
              <svg
                className="w-8 h-8"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 6v12" />
                <path d="M6 12h12" />
              </svg>
            </div>
            <div className="text-lg text-gray-700">
              <strong>Clear Communication:</strong> We keep you informed at
              every step of the Odoo implementation process.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
